import React from 'react'
import { Tab, Tabs, LayoutBand } from '@fs/zion-ui'
import { NotFound, useLocation } from '@fs/zion-router'
import useAdmin from '../hooks/use-admin'

const CentersTable = React.lazy(() => import('../components/AdminConsole/Centers/CentersTable/CentersTable'))
const RolesTable = React.lazy(() => import('../components/AdminConsole/Roles/RolesTable/RolesTable'))
const PartnersView = React.lazy(() => import('../components/AdminConsole/Partners/PartnersView/PartnersView'))

// Admin route paths
const ADMIN_ROUTES = {
  CENTERS: '/centers/admin/centers',
  ROLES: '/centers/admin/roles',
  PARTNERS: '/centers/admin/partners',
}

// Map URL paths to tab indices
const getTabIndexFromPath = (pathname) => {
  if (pathname.includes(ADMIN_ROUTES.ROLES)) return 1
  if (pathname.includes(ADMIN_ROUTES.PARTNERS)) return 2
  return 0 // default to Centers tab
}

export default function AdminConsole() {
  const { isAdmin, isLoading } = useAdmin()
  const location = useLocation()
  const activeTabIndex = getTabIndexFromPath(location.pathname)

  if (isLoading) {
    return null
  }
  return (
    <>
      {isAdmin === true ? (
        <LayoutBand>
          <Tabs fullWidth index={activeTabIndex}>
            <Tab title="Centers" to={ADMIN_ROUTES.CENTERS}>
              <CentersTable />
            </Tab>
            <Tab title="Roles" to={ADMIN_ROUTES.ROLES}>
              <RolesTable />
            </Tab>
            <Tab title="Partners" to={ADMIN_ROUTES.PARTNERS}>
              <PartnersView />
            </Tab>
          </Tabs>
        </LayoutBand>
      ) : (
        <NotFound />
      )}
    </>
  )
}
